import { create } from 'zustand';

interface AuthState {
  token: string | null;
  user: any | null;
  setAuth: (token: string, user: any) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('liber_token'),
  user: JSON.parse(localStorage.getItem('liber_user') || 'null'),
  setAuth: (token, user) => {
    localStorage.setItem('liber_token', token);
    localStorage.setItem('liber_user', JSON.stringify(user));
    set({ token, user });
  },
  logout: () => {
    localStorage.removeItem('liber_token');
    localStorage.removeItem('liber_user');
    set({ token: null, user: null });
  }
}));
